module.exports = __webpack_public_path__ + "static/img/success.d0590d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/success.png
// module id = 2dut
// module chunks = 1